import React, { useEffect, useState } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Logo from "../assets/Images/logo.png";
import Fade from '@mui/material/Fade';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { KeyboardArrowDown, MailOutline } from "@mui/icons-material";
import SignUp from "./SignUpDialogs/SignUp";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Link, useNavigate } from "react-router-dom";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { Badge, Divider, Drawer, List, ListItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SignUpAs from "./SignUpDialogs/SignUpAs";

const Navbar = () => {

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorEl2, setAnchorEl2] = React.useState(null);
    const [anchorEl3, setAnchorEl3] = React.useState(null);
    const [anchorEl4, setAnchorEl4] = React.useState(null);
    const [addSignUpAction, setAddSignUpAction] = useState(false);
    const open = Boolean(anchorEl);
    const open2 = Boolean(anchorEl2);
    const open3 = Boolean(anchorEl3);
    const open4 = Boolean(anchorEl4);
    const navigate = useNavigate();
    const { user } = useSelector((state) => ({ ...state }));
    const pages = [{
        name: 'Home',
        item: []
    },
    {
        name: 'Find Jobs',
        item: []
    },
    {
        name: 'Employees',
        item: [{
            name: 'Companies',
            url: '/'
        }, {
            name: 'Job Available',
            url: '/'
        }, {
            name: 'Find a Candidate',
            url: '/'
        }, {
            name: 'FAQ',
            url: '/'
        }, {
            name: 'Sign Up',
            url: '/'
        }
        ],
        open: open,
        anchorEl: anchorEl
    },
    {
        name: 'Coach/Mentor',
        item: [{
            name: 'Find a Coach',
            url: '/'
        }, {
            name: 'Services',
            url: '/'
        }, {
            name: 'FAQ',
            url: '/'
        }, {
            name: 'Sign Up',
            url: '/'
        }
        ],
        open: open2,
        anchorEl: anchorEl2
    },
    {
        name: 'Candidates',
        item: [{
            name: 'Find a job',
            url: '/'
        }, {
            name: 'Whats Trending',
            url: '/'
        }, {
            name: 'Find a Coach',
            url: '/'
        }, {
            name: 'Look at Companies',
            url: '/'
        }, {
            name: 'FAQ of Candidates',
            url: '/'
        }, {
            name: 'Sign Up',
            url: '/'
        },
        ],
        open: open3,
        anchorEl: anchorEl3
    },
    {
        name: 'Blogs',
        item: []
    }];

    const signUpButtonStyle = {
        background: '#2544EE',
        borderRadius: '7px',
        color: '#fff',
        width: '150px',
        height: '46px',
        "&:hover": {
            backgroundColor: '#2544EE'
        }
    }

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleClick = (name, event) => {
        if (name == "Employees") {
            setAnchorEl(event.currentTarget);
        } else if (name == "Coach/Mentor") {
            setAnchorEl2(event.currentTarget);
        } else {
            setAnchorEl3(event.currentTarget);
        }
    };
    const handleClose = (name) => {
        if (name == "Employees") {
            setAnchorEl(null);
        } else if (name == "Coach/Mentor") {
            setAnchorEl2(null);
        } else {
            setAnchorEl3(null);
        }
    };

    const handleClick2 = (event) => {
        setAnchorEl4(event.currentTarget);
    };
    const handleClose2 = () => {
        setAnchorEl4(null);
    };


    const dispatch = useDispatch();
    const handleLogout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("rememberMe");
        handleClose2();
        dispatch({
            type: "LOG_OUT",
        });
        navigate('/');
    }

    const handleProfileRedirect = () => {
        if (user.role.trim().toLowerCase() == "coach") {
            navigate('/coach/create-profile');
        } else if (user.role.trim().toLowerCase() == "candidate") {
            navigate('/candidate/create-profile');
        } else {
            navigate('/profile');
        }
    }

    const handleDashboardRedirect = () => {
        console.log(user?.isProfileCompleted);
        if (user?.isProfileCompleted == "true") {
            if (user.role.trim().toLowerCase() == "coach") {
                navigate('/coach/dashboard');
            } else if (user.role.trim().toLowerCase() == "candidate") {
                navigate('/candidate/dashboard');
            } else {
                navigate('/employer/dashboard');
            }
        } else {
            handleProfileRedirect();
        }
    }

    const [state, setState] = React.useState({
        left: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    return (
        <>
            <AppBar position="fixed" sx={{ background: 'inherit', boxShadow: 'none', top: '0px' }}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Link to='/'>
                            <img src={Logo} alt="PPLACD" style={{ width: '200px', height: '70px' }} />
                        </Link>

                        {/* Mobile view */}
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: 'end' }}>
                            <React.Fragment >
                                <Button onClick={toggleDrawer('left', true)}>
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="#000"
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                </Button>
                                <Drawer
                                    anchor={'left'}
                                    open={state['left']}
                                    onClose={toggleDrawer('left', false)}
                                >
                                    <List>
                                        {pages.map((page, index) => (
                                            <>
                                                {
                                                    page.item.length > 0
                                                        ?
                                                        <Accordion
                                                            sx={{ boxShadow: 'none', margin: '0px' }}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMoreIcon />}
                                                                aria-controls="panel1a-content"
                                                                id="panel1a-header"
                                                                sx={{ boxShadow: 'none', margin: '0px' }}
                                                            >
                                                                <Typography>{page.name}</Typography>
                                                            </AccordionSummary>
                                                            <AccordionDetails sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                                                {page.item.map((item, index) => (
                                                                    <Typography key={index} className="text1Mid">
                                                                        {item.name}
                                                                    </Typography>
                                                                ))}
                                                            </AccordionDetails>
                                                        </Accordion>
                                                        :
                                                        <ListItem key={index} onClick={handleCloseNavMenu}>
                                                            <Typography textAlign="center" className="text1Mid">{page.name}</Typography>
                                                        </ListItem>

                                                }
                                            </>

                                        ))}
                                    </List>
                                </Drawer>
                            </React.Fragment>
                            {/* <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="#000"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                {pages.map((page, index) => (
                                    <>
                                        {
                                            page.item.length > 0
                                                ?
                                                <Accordion
                                                    sx={{ boxShadow: 'none', margin: '0px' }}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header"
                                                        sx={{ boxShadow: 'none', margin: '0px' }}
                                                    >
                                                        <Typography>{page.name}</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                                        {page.item.map((item, index) => (
                                                            <Typography key={index} className="text1Mid">
                                                                {item.name}
                                                            </Typography>
                                                        ))}
                                                    </AccordionDetails>
                                                </Accordion>
                                                :
                                                <MenuItem key={index} onClick={handleCloseNavMenu}>
                                                    <Typography textAlign="center" className="text1Mid">{page.name}</Typography>
                                                </MenuItem>

                                        }
                                    </>

                                ))}
                            </Menu> */}
                        </Box>

                        {/* Laptop view */}
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, marginLeft: '15%' }}>
                            {window.location.pathname === '/' && pages.map((page, index) => (
                                <>
                                    {
                                        page.item.length > 0
                                            ?
                                            <>
                                                <Button
                                                    key={index}
                                                    id="fade-button"
                                                    aria-controls={page.open ? 'fade-menu' : undefined}
                                                    aria-haspopup="true"
                                                    aria-expanded={page.open ? 'true' : undefined}
                                                    onClick={(event) => handleClick(page.name, event)}
                                                    sx={{ my: 2, color: '#090909', opacity: '0.5', display: 'block', padding: '0px 15px', textTransform: 'none', fontSize: '17px' }}
                                                    className="text1Mid"
                                                >
                                                    {page.name} <KeyboardArrowDown sx={{ fontSize: '17px' }} />
                                                </Button>
                                                <Menu
                                                    id="fade-menu"
                                                    MenuListProps={{
                                                        'aria-labelledby': 'fade-button',
                                                    }}
                                                    anchorEl={page.anchorEl}
                                                    open={page.open}
                                                    onClose={(event) => handleClose(page.name, event)}
                                                    TransitionComponent={Fade}
                                                >
                                                    {page.item.map((item, index) => (
                                                        <>
                                                            <MenuItem onClick={handleClose} key={index} className="text1Mid" sx={{ textAlign: 'center', mx: 5, p: 0, justifyContent: 'center' }}>{item.name}</MenuItem>
                                                            <Divider sx={{ height: '1px', backgroundColor: '#d2d2d2', m: 0 }} />
                                                        </>
                                                    ))}
                                                </Menu>
                                            </>
                                            :
                                            <Button
                                                key={index}
                                                onClick={handleCloseNavMenu}
                                                sx={{ my: 2, color: '#090909', display: 'block', padding: '0px 15px', textTransform: 'none', fontSize: '17px', opacity: '0.5' }}
                                                className="text1Mid"
                                            >
                                                {page.name}
                                            </Button>

                                    }
                                </>

                            ))}
                        </Box>
                        {
                            window.location.pathname !== '/'
                                ?
                                <>
                                    <NotificationsNoneIcon sx={{ color: '#000', opacity: '0.5', fontSize: '1.75rem' }} />
                                    <Badge overlap="circular" color="error" variant="dot" sx={{ margin: '0px 1.25rem' }}>
                                        <MailOutline sx={{ color: '#000', opacity: '0.5', fontSize: '1.75rem' }} />
                                    </Badge>
                                </>
                                :
                                ""
                        }
                        {
                            user._id != undefined
                                ?
                                <>
                                    {
                                        user.avatar != ""
                                            ?
                                            <img
                                                src={user.avatar}
                                                alt={user.name}
                                                style={{ width: '45px', borderRadius: '50%', cursor: 'pointer', height: '45px' }}
                                                aria-controls={open4 ? 'demo-positioned-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={open4 ? 'true' : undefined}
                                                onClick={handleClick2}
                                            />
                                            :
                                            <AccountCircleIcon
                                                aria-controls={open4 ? 'demo-positioned-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={open4 ? 'true' : undefined}
                                                onClick={handleClick2}
                                                sx={{ color: '#090909', opacity: '0.5', fontSize: '40px', cursor: 'pointer' }}
                                            />
                                    }
                                    <Menu
                                        anchorEl={anchorEl4}
                                        open={open4}
                                        onClose={handleClose2}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                    >
                                        <MenuItem onClick={handleDashboardRedirect}>My Dashboard</MenuItem>
                                        <MenuItem onClick={handleProfileRedirect}>My Profile</MenuItem>
                                        {/* <MenuItem onClick={handleClose}>My account</MenuItem> */}
                                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                                    </Menu>
                                </>
                                :
                                <Button sx={signUpButtonStyle} onClick={() => setAddSignUpAction(true)} className="m-hide text1Mid">
                                    SignUp
                                </Button>
                        }


                        {/* Code for showing user dropdown after signup */}
                        {/* <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                {settings.map((setting) => (
                                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                        <Typography textAlign="center">{setting}</Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box> */}
                    </Toolbar>
                </Container>
            </AppBar>
            <SignUpAs
                addSignUpAsAction={addSignUpAction}
                setAddSignUpAsAction={setAddSignUpAction}
            />
        </>
    );
}

export default Navbar;